import {
    Box,
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    HStack,
    Input,
    InputGroup, InputLeftElement,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useRef } from "react";
import SponsorService from "../../../services/admin/sponsors.service";




export const CreateBudgetModal: React.FC<any> = ({ isOpen, onClosed, isBudget = false, sponsorId ,reload}: { isBudget: boolean, isOpen: any, onClosed: any, sponsorId: string, reload:any }) => {
    const toast = useToast();
    const cancelRef = useRef().current;


   
    const formik = useFormik({
        validate: (values: any) => {
            const errors: any = {};
            if (!values.amount) {
                errors.amount = 'amount  required'
            }
            if (!values.channel) {
                errors.channel = 'please signify payment mode'
            }




            return errors;
        },
        initialValues: {
            amount: '',
            channel: '',

        },
        onSubmit: async (values) => {

            try {

                const paymentData: any = {
                    sponsor_id: sponsorId,
                    amount: values.amount,
                    channel: values.channel,
                }
                const payBudget = await SponsorService.createSponsorBudget( paymentData);
                


                if (payBudget) {
                    toast({
                        title: "Budget Payment",
                        description: 'Budget successfully credited',
                        status: "success",
                        duration: 2000,
                        onCloseComplete: () => onClosed()
                    })
                    reload()

                }




            } catch (error: any) {
                toast({
                    title: "Budget Payment",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
        }
    })




    return (
        <>

            <Modal isOpen={isOpen && isBudget} onClose={onClosed} scrollBehavior="inside" closeOnOverlayClick={true} size="sm">
                <ModalOverlay />
                <ModalContent borderRadius={5} px={4} >
                    <ModalHeader >
                        {<Text fontSize='21px' fontWeight='700' pb={1} textTransform="none" pl={3} color="#2B2B2B" >Create Budget</Text>}
                    </ModalHeader>
                    <ModalCloseButton size="sm" />
                    <ModalBody pb={6}>

                        <Box mt={2}>
                            <form onSubmit={formik.handleSubmit} >

                                <FormControl mt={4} isInvalid={(formik.errors.amount && formik.touched.amount) ? true : false}>
                                    <FormLabel fontWeight="700" color="#757575" fontSize='14px'>Amount</FormLabel>
                                    <InputGroup>
                                        <InputLeftElement color="brand.subtitle" pointerEvents="none" children={<Text>₦</Text>} />

                                        <Input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            placeholder="Enter amount"
                                            onChange={formik.handleChange}
                                            fontSize={13}
                                        />
                                    </InputGroup>

                                    <FormErrorMessage fontSize={12} >{formik.errors.amount}</FormErrorMessage>
                                </FormControl>
                                <FormControl mt={4} isInvalid={formik.errors.channel && formik.touched.channel ? true : false} >
                                    <FormLabel fontWeight="700" color="#757575" fontSize='14px'>Channel: </FormLabel>
                                    <Input
                                        type="text"
                                        id="channel"
                                      
                                        name="channel"
                                        placeholder="Enter payment channel"
                                        onChange={formik.handleChange}
                                        fontSize={13}
                                    />

                                    <FormErrorMessage fontSize={12}>{formik.errors.channel} </FormErrorMessage>
                                </FormControl>

                                <Flex mt={12} justifyContent="end">
                                    <HStack>
                                        <Button size="sm" px={6} fontSize={12} ref={cancelRef} onClick={() => onClosed()}>
                                            Cancel
                                        </Button>
                                        <Button colorScheme="red" type="submit" isLoading={formik.isSubmitting}

                                            size="sm" px={6} fontSize={12} > Create</Button>

                                    </HStack>
                                </Flex>
                            </form>

                        </Box>



                    </ModalBody>

                    <ModalFooter>
                    </ModalFooter>
                </ModalContent>

            </Modal>


        </>
    )




}
